import { useNavState } from '@/providers/NavStateProvider';
import { useEffect, useState } from 'react';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { MotionDiv } from '@/components/element/MotionDiv';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { v4 as uuidV4 } from 'uuid';
import { ModalConfirm } from '@/components/element/modal/ModalConfirm';
import { useDestroySlackSetting } from '@/hooks/api/2250_destroy_slack_setting';
import { toastApiError, toastSuccess } from '@/lib/toast';
import { useWorkspaceInvalidate } from '@/hooks/api/0101_workspace';
import { useLoading } from '@/providers/LoadingProvider';

export const NotificationSetting = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('通知設定'), []);
  useEffect(() => setBreadcrumbs([]), []);

  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();
  const [slackConnectState, setSlackConnectState] = useState(uuidV4());
  const [connectUri, setConnectUri] = useState(
    `https://slack.com/oauth/v2/authorize?client_id=${
      process.env.REACT_APP_SLACK_CLIENT_ID
    }&scope=chat:write,chat:write.customize,im:write,groups:write,channels:manage,mpim:write&redirect_uri=${
      process.env.REACT_APP_SITE_URL
    }/w/${_w_!.identifier}/user_setting/notification/connect/slack/callback&state=${slackConnectState}`
  );

  const { mutate, isPending, isSuccess, error } = useDestroySlackSetting();
  const { invalidate: invalidateWorkspace } = useWorkspaceInvalidate(_w_!.identifier);

  useEffect(() => setShowLoading(isPending), [isPending]);
  useEffect(() => toastApiError(error), [error]);

  useEffect(() => {
    if (isSuccess) {
      invalidateWorkspace();
      toastSuccess('Slack連携を解除しました');
    }
  }, [isSuccess]);

  const onConnectClick = () => {
    Cookies.set('slack_connect_state', slackConnectState, { sameSite: 'strict' });
  };

  const onDisconnectClick = () => {
    mutate({ identifier: _w_!.identifier });
  };

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-12 col-lg-6 mx-auto">
            <MotionDiv className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">通知設定</h5>
                </div>
              </div>
              <div className="card-body pt-0 row">
                <div className="form-group">
                  <label>Slack連携</label>
                  <div>
                    {me!.has_slack_setting ? (
                      <Link
                        to={``}
                        className="btn bg-gradient-danger btn-icon"
                        data-bs-toggle="modal"
                        data-bs-target={`#disconnectConfirm`}
                      >
                        <i className="fas fa-minus-circle"></i>連携解除
                      </Link>
                    ) : (
                      <Link to={connectUri} onClick={onConnectClick}>
                        <img
                          alt="Add to Slack"
                          height="40"
                          width="139"
                          src="https://platform.slack-edge.com/img/add_to_slack.png"
                          srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
                        />
                      </Link>
                    )}

                    <ModalConfirm
                      modalId={'disconnectConfirm'}
                      okClicked={onDisconnectClick}
                      message={'連携を解除します。よろしいですか？'}
                    />
                  </div>
                  <div className="text-xs text-muted mt-2">通知をSlackで受け取れます。</div>
                </div>
              </div>
            </MotionDiv>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
